import { telegramWorkflowMessageIdentity } from './workflowMessageIdentity';
import { getTelegramAiMessagePeer } from './telegramAiPeer';
import {
    Api_AutoReply,
    Api_ResetAutoReply,
    getMeta,
    Api_TgBot_Report,
    Api_AiSendChat
} from "../api";
import { Database } from "../../config/databases";
import IDBStorage from "../../lib/files/idb";
import DATABASE_STATE from "../../config/databases/state";
import rootScope from "../../lib/rootScope";
import {
    getUserNameByPeerId,
    getFullNameByPeerId,
    getSessionStorage,
    setSessionStorage,
} from "../utils/index";
import readOnlineFile from "./../utils/readFile";
import aiLogger from "./AiLogger";

const telegramAiPeerContext = {
    getSelfId: () => rootScope.myId,
    getUser: (id: string) => rootScope.managers.appUsersManager.getUser(id as any)
};

const second = 3;
// 最大重试次数
const MAX_RETRIES = 3;
// 重试延迟基数（毫秒）
const RETRY_DELAY_BASE = 1000;
// 处理中的用户请求映射，防止重复处理
const processingUsers = new Map();

export interface AiReplyOptions {
    [key: string]: any;
}

// API响应接口
interface ApiResponse<T = any> {
    code: number;
    data: T;
    message?: string;
}

// 判断是否为TG官方通知账号
function isTGNotificationAccount(peerId: number): boolean {
    if (
        peerId == 777000 ||
        peerId == 429000 ||
        peerId == 333000 ||
        peerId == 42777
    ) {
        return true;
    }
    return false;
}

async function isFansOpenAi(sysType: any, sysId: any) {
    let res = await getMeta({ sysType, sysId }) as unknown as ApiResponse;
    if (res.code == 200) {
        if (res.data.aiReply == 1) {
            return true;
        } else {
            return false;
        }
    } else {
        return false;
    }
}

function getAIName(userInfo: any) {
    let firstName = userInfo.first_name ?? "";
    let split = firstName.length > 0 ? " " : "";
    let lastName = userInfo.last_name ?? "";
    return firstName + split + lastName;
}

// 获取消息类型
function getTypeOfMsg(options: any): string {
    const msg = options.message;
    console.log("~~getTypeOfMsg被调用 :>> ", msg);

    if (msg._ == 'message') {
        // 如果存在media，则判断media的类型
        if (msg.media) {
            if (msg.media._ == 'messageMediaDocument') {
                if (msg.media.document.type == 'video' || msg.media.document.type == 'round') {
                    return 'video';
                } else {
                    return msg.media.document.type;
                }
            }
        }

        return 'text';
    }

    if (msg._ == 'messageService') {
        return msg.action._;  //messageActionPhoneCall
    }

    return 'text'; // 默认返回文本类型
}

// 获取消息内容
function getMessageOfMsg(options: any, type: string): string {
    const msg = options.message;

    if (type == "text") {
        return msg.message || '';
    }

    if (type == "sticker") {
        return msg.media?.document?.stickerEmojiRaw || '[贴纸]';
    }

    if (type == "messageActionPhoneCall") {
        return "[通话]";
    }

    if (type == "voice") {
        return "[语音]";
    }

    if (type == "video") {
        return "[视频]";
    }

    if (type == "round") {
        return "[视频留言]";
    }

    if (type == "gif") {
        return "[GIF动图]";
    }

    if (type == "photo") {
        return "[图片]";
    }

    return "[未知消息类型]";
}

// 将消息类型转换为API需要的格式
function translateMessageType(msgType: string): string {
    switch (msgType) {
        case 'text':
            return 'MSG_TEXT';
        case 'photo':
            return 'MSG_IMAGE';
        case 'video':
        case 'round':
            return 'MSG_VIDEO';
        case 'voice':
            return 'MSG_VOICE';
        case 'sticker':
            return 'MSG_STICKER';
        case 'gif':
            return 'MSG_GIF';
        case 'messageActionPhoneCall':
            return 'MSG_CALL';
        default:
            return 'MSG_TEXT';
    }
}

// 获取用户AI回复状态
async function getAIReplyStatus() {
    const status = sessionStorage.getItem("aiReplyStatus");
    return status ? parseInt(status) : 0;
}



// 使用重试机制执行异步操作
async function withRetry<T>(operation: () => Promise<T> | T, context: string, userId: number, maxRetries = MAX_RETRIES): Promise<T> {
    let lastError;
    for (let attempt = 1; attempt <= maxRetries; attempt++) {
        try {
            const result = await operation();
            // 如果成功，返回结果
            return result;
        } catch (error) {
            lastError = error;
            console.error(`${context} 失败 (尝试 ${attempt}/${maxRetries}):`, error);
            aiLogger.logError(userId, error, `${context} - 尝试 ${attempt}/${maxRetries}`);

            if (attempt < maxRetries) {
                // 指数退避策略，增加每次重试的延迟
                const delay = RETRY_DELAY_BASE * Math.pow(2, attempt - 1);
                // 添加一些随机性避免所有请求同时重试
                const jitter = Math.random() * 500;
                await new Promise(resolve => setTimeout(resolve, delay + jitter));
            }
        }
    }
    // 所有重试都失败后抛出最后一个错误
    throw lastError;
}

// 防抖策略：确保同一用户的请求不会重复处理
function preventReprocessing(userId: number, timeoutMs = 5000): boolean {
    if (processingUsers.has(userId)) {
        console.log(`用户 ${userId} 的消息正在处理中，跳过重复处理`);
        return false;
    }

    processingUsers.set(userId, Date.now());
    setTimeout(() => {
        processingUsers.delete(userId);
    }, timeoutMs);

    return true;
}

// 发送文本消息给用户
function Send_text_ai(peerId: number, text: string): void {
    try {
        rootScope.managers.appMessagesManager.sendText(peerId, text);
    } catch (error) {
        console.error('发送文本消息失败:', error);
        aiLogger.logError(peerId, error, '发送文本消息');
    }
}

// 发送图片消息给用户
function Send_image_ai(peerId: number, url: string): void {
    try {
        fetch(url)
            .then(r => r.blob())
            .then(blob => {
                const file = new File([blob], "ai_image.jpg", { type: 'image/jpeg' });
                rootScope.managers.appMessagesManager.sendFile(peerId, {
                    file,
                    isMedia: true,
                    width: 800,
                    height: 600
                });
            })
            .catch(error => {
                console.error('发送图片消息失败:', error);
                aiLogger.logError(peerId, error, '发送图片消息-fetch');
            });
    } catch (error) {
        console.error('发送图片消息失败:', error);
        aiLogger.logError(peerId, error, '发送图片消息');
    }
}

async function getReplyFormAi(received_msg: any) {
    const peerId = received_msg?.message?.peerId;
    const sourceSelf = String(received_msg?.sourceSelfId ?? rootScope.myId);
    console.log(`~~DEBUG_LOG: getReplyFormAi开始 peerId=${peerId}`);

    try {
        if (String(rootScope.myId) !== sourceSelf ||
            !await getTelegramAiMessagePeer(received_msg?.message, telegramAiPeerContext) ||
            String(rootScope.myId) !== sourceSelf) return false;
        const { userId, sourceMessageId } = telegramWorkflowMessageIdentity(received_msg.message);
        // 记录收到的用户消息 - 直接尝试记录，不放在try-catch中
        console.log(`~~DEBUG_LOG: 尝试记录收到的用户消息 peerId=${peerId}`);

        // 获取消息类型和内容
        let message_type = "unknown";
        let message = "";

        try {
            message_type = getTypeOfMsg(received_msg);
            message = getMessageOfMsg(received_msg, message_type);
            console.log(`~~DEBUG_LOG: 获取消息类型和内容成功 type=${message_type}, content=${message}`);
        } catch (parseError) {
            console.error(`~~DEBUG_LOG: 解析消息失败:`, parseError);
            message_type = "text";
            message = "[消息解析失败]";
        }

        let type = translateMessageType(message_type);

        // 获取用户信息
        let usernames, fullName;
        try {
            console.log(`~~DEBUG_LOG: 开始获取用户信息 peerId=${peerId}`);
            [usernames, fullName] = await Promise.all([
                withRetry(() => getUserNameByPeerId(peerId), '获取用户名', peerId),
                withRetry(() => getFullNameByPeerId(peerId), '获取用户全名', peerId)
            ]);
            console.log(`~~DEBUG_LOG: 获取用户信息成功 usernames=${usernames}, fullName=${fullName}`);
        } catch (userInfoError) {
            console.error(`~~DEBUG_LOG: 获取用户信息失败:`, userInfoError);
            usernames = "unknown";
            fullName = "未知用户";
        }

        // 强制记录日志以确认aiLogger是否工作
        console.log(`~~DEBUG_LOG: aiLogger状态:`, {
            initialized: typeof aiLogger !== 'undefined' ? (aiLogger as any).initialized : false,
            hasSessionId: typeof aiLogger !== 'undefined' && typeof (aiLogger as any).sessionId !== 'undefined',
            hasStorage: typeof aiLogger !== 'undefined' && typeof (aiLogger as any).storage !== 'undefined'
        });

        // 安全访问window全局对象
        if (typeof window !== 'undefined') {
            (window as any)._debug_logs = (window as any)._debug_logs || [];
            (window as any)._debug_logs.push({
                time: new Date().toISOString(),
                peerId,
                message_type,
                message,
                usernames,
                fullName
            });
        }

        // 记录消息到aiLogger
        try {
            console.log(`~~DEBUG_LOG: 尝试通过aiLogger记录消息`);
            aiLogger.logReceivedMessage(
                peerId,
                message,
                {
                    type: message_type,
                    translatedType: type,
                    fullName,
                    usernames
                }
            );
            console.log(`~~DEBUG_LOG: aiLogger记录消息成功`);
        } catch (logError) {
            console.error(`~~DEBUG_LOG: aiLogger记录消息失败:`, logError);

            // 尝试手动存储日志
            try {
                const storage = new IDBStorage(DATABASE_STATE, 'aiLogs');
                const logItem = {
                    timestamp: Date.now(),
                    formattedTime: new Date().toISOString(),
                    type: "RECEIVED_MESSAGE_MANUAL",
                    level: "INFO",
                    message: `收到用户 ${peerId} 的消息: ${message}`,
                    data: { manual_recovery: true }
                };

                console.log(`~~DEBUG_LOG: 尝试手动存储日志`);
                const existingLogs = await storage.get(peerId.toString()) || [];
                await storage.save(peerId.toString(), [...existingLogs, logItem]);
                console.log(`~~DEBUG_LOG: 手动存储日志成功`);
            } catch (manualLogError) {
                console.error(`~~DEBUG_LOG: 手动存储日志也失败:`, manualLogError);
            }
        }

        // 发送消息到AI服务
        console.log(`~~DEBUG_LOG: 准备发送消息到AI服务`);
        let apiResponse = null;

        try {
            const res = await withRetry(async () => {
                const telegramPeer = await getTelegramAiMessagePeer(received_msg.message, telegramAiPeerContext);
                if (!telegramPeer || String(rootScope.myId) !== sourceSelf) {
                    return {code: -1, data: null, message: 'Telegram AI仅处理普通用户私聊'};
                }
                return Api_AiSendChat({
                type: type,
                message,
                fullName,
                userName: fullName,
                userId,
                sourceMessageId,
                workgroupCode: sessionStorage.getItem("tolink_groupCode") ?? null,
                workgroupName: sessionStorage.getItem("tolink_groupName") ?? null,
                groupMemberId: sessionStorage.getItem("tolink_groupMemberId") ?? null,
                workTgname: rootScope.myId,
                proxyUserName: sourceSelf,
                tag: null,
                fromUser: true,
                telegramPeer,
                debugStatus: "",
                chatChannel: "Telegram",
                maxReplyCount: "1000",
                parameters: {
                    nickname: "",
                    age: "18",
                    story: "",
                }
                });
            }, '发送AI消息', peerId) as unknown as ApiResponse<any>;

            apiResponse = res;
            console.log(`~~DEBUG_LOG: AI服务响应成功`, res);

            // 记录API成功响应
            if (typeof window !== 'undefined') {
                (window as any)._debug_logs.push({
                    time: new Date().toISOString(),
                    event: "API_SUCCESS",
                    peerId,
                    response: res
                });
            }

            // 成功码：新接口走统一信封（code: 200），旧的 n8n webhook 用 code: 0。
            // 保留对 0 的兼容，避免漏改某条路径时被当成失败；负值（如 -1，配置缺失）
            // 一律算失败。
            if (res.code === 0 || res.code === 200) {
                return true;
            } else {
                console.error(`~~DEBUG_LOG: API返回错误码: ${res.code}`, res.message);
                return false;
            }
        } catch (apiError) {
            console.error(`~~DEBUG_LOG: 调用AI服务API失败:`, apiError);

            // 记录API失败
            if (typeof window !== 'undefined') {
                (window as any)._debug_logs.push({
                    time: new Date().toISOString(),
                    event: "API_FAILURE",
                    peerId,
                    error: apiError.toString()
                });
            }

            return false;
        }
    } catch (error) {
        console.error(`~~DEBUG_LOG: getReplyFormAi主函数异常:`, error);

        // 记录整体错误
        if (typeof window !== 'undefined') {
            (window as any)._debug_logs.push({
                time: new Date().toISOString(),
                event: "FATAL_ERROR",
                peerId,
                error: error.toString()
            });
        }

        return false;
    }
}

export async function initAiReply(options: AiReplyOptions) {
    const { message } = options;
    const peerId = message.peerId;
    const sourceSelfId = String(options.sourceSelfId ?? rootScope.myId);

    console.log("~~initAiReply开始处理消息 :>> ", options);

    try {
        // Queue entries and direct callers must satisfy the same current peer policy.
        if (String(rootScope.myId) !== sourceSelfId ||
            !await getTelegramAiMessagePeer(message, telegramAiPeerContext) ||
            String(rootScope.myId) !== sourceSelfId) return;
        // 检查是否已在处理该用户的消息
        if (!preventReprocessing(peerId)) {
            console.log(`~~用户 ${peerId} 的消息正在处理中，跳过`);
            return;
        }

        // 尝试重新初始化AI日志系统并记录开始处理
        await aiLogger.reinitialize();
        if (String(rootScope.myId) !== sourceSelfId) return;

        // 强制记录日志到控制台，确保可追踪
        console.log(`~~[处理日志] 开始处理用户 ${peerId} 的消息:`, message);

        // 开始性能监控
        aiLogger.startPerformanceMetric('initAiReply_total');

        // 开始新的AI会话并记录
        aiLogger.startSession(peerId, options);
        console.log("~~已开启AI会话，准备获取回复 :>> ");

        // 记录消息类型和内容到控制台
        const msgType = getTypeOfMsg(options);
        const msgContent = getMessageOfMsg(options, msgType);
        console.log(`~~[消息内容] 类型:${msgType}, 内容:${msgContent}`);

        // 获取AI回复
        let res = await getReplyFormAi({...options, sourceSelfId});
        console.log("~~getReplyFormAi处理结果 :>> ", res);

        if (res) {
            // console.log(`~~开始查询AI响应`);
            // let ai_msg_res = await queryAiMsg(peerId);

            // // 更新UI显示（如果存在）
            // try {
            //     let el = document.querySelector(
            //         `[data-peer-id="${peerId}"]`
            //     );
            //     let aibox = el?.querySelector(".ai-status-row");
            //     if (aibox) {
            //         aibox.innerHTML = `AI已启动`;
            //         console.log("~~更新AI状态UI成功");
            //     }
            // } catch (uiError) {
            //     console.error("~~更新AI状态UI失败:", uiError);
            // }

            // console.log("~~AI响应查询结果 :>> ", ai_msg_res);
        } else {
            // AI回复失败，记录会话结束
            console.log(`~~AI回复失败，结束会话`);
            aiLogger.endSession(peerId, {
                code: -1,
                message: 'AI回复失败',
                error: 'Failed to get AI reply'
            });
        }

        aiLogger.endPerformanceMetric(peerId, 'initAiReply_total', '完成AI回复全流程');
    } catch (error) {
        console.error("~~AI回复出错:", error);
        // 记录错误
        try {
            aiLogger.logError(peerId, error, 'AI回复初始化');
            aiLogger.endSession(peerId, {
                code: -1,
                message: 'AI回复初始化错误',
                error: error.toString()
            });
        } catch (logError) {
            console.error("~~记录错误日志失败:", logError);
        }
    } finally {
        // 确保处理标记最终会被清除
        setTimeout(() => {
            processingUsers.delete(peerId);
            console.log(`~~已清除用户 ${peerId} 的处理标记`);
        }, 10000);
    }
}

// 添加全局辅助函数用于调试
if (typeof window !== 'undefined') {
    (window as any).checkAiLogs = async function (peerId?: number) {
        console.log("==== AI日志系统检查开始 ====");

        // 检查aiLogger对象状态
        console.log("aiLogger状态:", {
            exists: typeof aiLogger !== 'undefined',
            initialized: typeof aiLogger !== 'undefined' ? (aiLogger as any).initialized : false,
            hasStorage: typeof aiLogger !== 'undefined' && typeof (aiLogger as any).storage !== 'undefined'
        });

        // 检查IndexedDB
        try {
            const storage = new IDBStorage(DATABASE_STATE, 'aiLogs');
            console.log("尝试直接访问日志存储");

            // 获取全部键
            try {
                // 检查storage是否有getKeys方法
                const keys = typeof storage.getKeys === 'function' ? await storage.getKeys() : [];
                console.log(`找到 ${keys.length} 个日志键`, keys);

                // 如果提供了特定peerId，获取该用户的日志
                if (peerId) {
                    try {
                        // 使用aiLogger新的会话摘要功能
                        console.log("===== 用户会话摘要 =====");
                        const sessionSummaries = await aiLogger.getSessionSummaries(peerId);
                        console.log(`找到 ${sessionSummaries.length} 个会话:`);

                        for (const summary of sessionSummaries) {
                            console.log(`
会话ID: ${summary.sessionId}
起始时间: ${new Date(summary.startTime).toLocaleString()}
结束时间: ${new Date(summary.endTime).toLocaleString()}
消息数量: ${summary.messageCount}
第一条消息: ${summary.firstMessage || '无'}
`);
                        }

                        // 如果有会话，展示第一个会话的详细信息
                        if (sessionSummaries.length > 0) {
                            const firstSessionId = sessionSummaries[0].sessionId;
                            console.log(`===== 最新会话详情 (${firstSessionId}) =====`);
                            const sessionLogs = await aiLogger.getSessionLogs(peerId, firstSessionId);

                            // 按类型统计
                            const typeCounts: Record<string, number> = {};
                            sessionLogs.forEach((log: any) => {
                                const type = log?.type || 'UNKNOWN';
                                typeCounts[type] = (typeCounts[type] || 0) + 1;
                            });
                            console.log("日志类型分布:", typeCounts);

                            // 显示会话流程
                            console.log("会话流程:");
                            sessionLogs.forEach((log, index) => {
                                console.log(`[${index + 1}] ${log.formattedTime} [${log.level}] ${log.type}: ${log.message}`);
                            });

                            // 专门展示QUERY_CHAT日志
                            console.log("\n===== Query Chat 日志 =====");
                            const queryChatLogs = sessionLogs.filter((log: any) => log.type === 'QUERY_CHAT');
                            if (queryChatLogs.length > 0) {
                                console.log(`找到 ${queryChatLogs.length} 条查询日志:`);
                                queryChatLogs.forEach((log, index) => {
                                    const attemptNumber = log.data?.attemptNumber || '未知';
                                    const code = log.data?.response?.code !== undefined ? log.data.response.code : '未知';
                                    const message = log.data?.response?.message || '无消息';
                                    console.log(`[${index + 1}] 第${attemptNumber}次查询 - 响应码: ${code}, 消息: ${message}`);

                                    // 如果是最后一次查询且是会话结束，显示结束信息
                                    if (log.data?.response?.finalQuery) {
                                        console.log(`  这是会话的最终查询，会话结束`);
                                    }
                                });

                                // 显示最后一次查询的完整响应
                                const lastQuery = queryChatLogs[queryChatLogs.length - 1];
                                console.log("\n最后一次查询的完整响应:");
                                console.log(lastQuery.data?.response || "无响应数据");
                            } else {
                                console.log("未找到任何query_chat日志");
                            }
                        }

                        // 获取所有日志（扁平化）
                        const allLogs = await aiLogger.getUserLogs(peerId);
                        console.log(`===== 用户所有日志 =====`);
                        console.log(`总日志数: ${allLogs.length}`);

                        // 检查旧格式日志
                        const relevantKeys = keys.filter(key => key.includes(peerId.toString()));
                        console.log(`与用户ID ${peerId} 相关的键:`, relevantKeys);

                        for (const key of relevantKeys) {
                            try {
                                const data = await storage.get(key);
                                if (data) {
                                    // 检查数据结构，判断是新格式还是旧格式
                                    if (Array.isArray(data)) {
                                        console.log(`键 "${key}" 包含 ${data.length} 条旧格式日志`);
                                    } else if (typeof data === 'object') {
                                        const sessionCount = Object.keys(data).length;
                                        console.log(`键 "${key}" 包含 ${sessionCount} 个会话（新格式）`);

                                        // 输出每个会话的信息
                                        for (const sessionId in data) {
                                            const logs = (data as any)[sessionId];
                                            if (Array.isArray(logs)) {
                                                console.log(`  - 会话 ${sessionId}: ${logs.length} 条日志`);
                                            }
                                        }
                                    }
                                } else {
                                    console.log(`键 "${key}" 不包含数据`);
                                }
                            } catch (err) {
                                console.error(`获取键 "${key}" 的日志失败:`, err);
                            }
                        }
                    } catch (err) {
                        console.error(`获取用户 ${peerId} 日志失败:`, err);

                        // 尝试直接查看存储
                        try {
                            let fullName = "未知用户";
                            try {
                                fullName = await getFullNameByPeerId(peerId) || "未知用户";
                            } catch (nameErr) {
                                console.error("获取用户名失败:", nameErr);
                            }

                            // 尝试使用新的键格式直接查询
                            const key = `${peerId}_${fullName}`;
                            console.log(`尝试直接查询键: ${key}`);

                            const data = await storage.get(key);
                            console.log("直接查询结果:", data);
                        } catch (directErr) {
                            console.error("直接查询也失败:", directErr);
                        }
                    }
                }
            } catch (err) {
                console.error("获取日志键失败:", err);
            }
        } catch (err) {
            console.error("访问日志存储失败:", err);
        }

        console.log("==== AI日志系统检查结束 ====");
        return "检查完成";
    };

    // 尝试添加一条测试日志
    (window as any).addTestLog = async function (peerId: number) {
        try {
            // 通过aiLogger尝试
            try {
                // 生成随机会话ID
                const testSessionId = `test_session_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;

                // 修改aiLogger的sessionId以便于测试
                (aiLogger as any).sessionId = testSessionId;

                // 添加测试日志
                aiLogger.logReceivedMessage(peerId, "这是一条测试用户消息", { test: true, type: "text" });
                setTimeout(() => {
                    aiLogger.logAiMessageSent(peerId, "这是一条测试AI回复", "text", { test: true });
                }, 100);
                setTimeout(() => {
                    aiLogger.logAiQueryResponse(peerId, { status: "success", message: "测试查询响应" });
                }, 200);

                console.log("通过aiLogger添加测试日志成功，会话ID:", testSessionId);
            } catch (err) {
                console.error("通过aiLogger添加测试日志失败:", err);
            }

            // 直接尝试
            try {
                const storage = new IDBStorage(DATABASE_STATE, 'aiLogs');

                // 创建一个测试会话ID
                const testSessionId = `direct_test_session_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;

                // 创建日志项
                const testLog = {
                    timestamp: Date.now(),
                    formattedTime: new Date().toISOString(),
                    type: "TEST_LOG",
                    level: "INFO",
                    message: `这是一条直接添加的测试日志 ${Date.now()}`,
                    sessionId: testSessionId,
                    data: { test: true }
                };

                // 尝试获取用户名
                let fullName = "测试用户";
                try {
                    fullName = await getFullNameByPeerId(peerId) || "测试用户";
                } catch (nameErr) {
                    console.error("获取用户名失败:", nameErr);
                }

                // 使用新的键格式
                const key = `${peerId}_${fullName}`;
                console.log(`使用键: ${key} 和会话ID: ${testSessionId}`);

                // 获取现有数据
                const existingSessions = await storage.get(key) as any || {};

                // 创建新的会话日志数组
                if (!existingSessions[testSessionId]) {
                    existingSessions[testSessionId] = [];
                }

                // 添加测试日志
                existingSessions[testSessionId].push(testLog);

                // 保存数据
                await storage.save(key, existingSessions);
                console.log("直接添加测试日志成功");

                // 提示用户检查日志
                console.log(`
============================
测试日志已添加成功！请运行以下命令查看：
window.checkAiLogs(${peerId})
============================
`);
            } catch (err) {
                console.error("直接添加测试日志失败:", err);
            }

            return "测试完成";
        } catch (err) {
            console.error("测试过程中发生错误:", err);
            return "测试失败";
        }
    };

    // 测试query_chat日志功能
    (window as any).testQueryChatLogs = async function (peerId: number) {
        try {
            // 生成随机会话ID
            const testSessionId = `test_query_chat_${Date.now()}_${Math.random().toString(36).substring(2, 9)}`;

            // 修改aiLogger的sessionId以便于测试
            (aiLogger as any).sessionId = testSessionId;

            // 模拟用户会话开始
            aiLogger.startSession(peerId, { testSession: true });
            console.log(`测试会话已开始，ID: ${testSessionId}`);

            // 模拟用户消息
            aiLogger.logReceivedMessage(peerId, "这是一条测试用户消息", { test: true, type: "text" });

            // 模拟多次query_chat查询
            const queryResponses = [
                { code: 0, message: "ai conversation in process......", data: null },
                { code: 0, message: "ai conversation in process......", data: { type: "thinking" } },
                { code: 0, message: "ai conversation in process......", data: { type: "MSG_TEXT", content: "我正在思考中..." } },
                { code: 200, message: "success", data: { type: "MSG_TEXT", content: "这是AI的最终回复" } }
            ];

            // 模拟多次查询的响应
            for (let i = 0; i < queryResponses.length; i++) {
                const attemptNumber = i + 1;
                const response = queryResponses[i];

                // 添加日志
                aiLogger.logQueryChat(peerId, response, attemptNumber);

                // 如果是最后一次查询，模拟发送消息
                if (i === queryResponses.length - 1) {
                    aiLogger.logAiMessageSent(peerId, response.data.content, "text", response);
                }

                // 添加延迟效果
                await new Promise(resolve => setTimeout(resolve, 200));
            }

            // 模拟会话结束
            aiLogger.endSession(peerId, {
                code: 200,
                message: "success",
                attemptNumber: queryResponses.length,
                finalQuery: true
            });

            console.log(`
============================
测试query_chat日志已添加成功！请运行以下命令查看：
window.checkAiLogs(${peerId})
============================
`);

            return "测试完成";
        } catch (err) {
            console.error("测试query_chat日志过程中发生错误:", err);
            return "测试失败";
        }
    };
}
